'use strict';
var elements = document.querySelectorAll('.population');
var statistic = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var element = _step.value;
        statistic.push(Number(element.textContent.replaceAll(',', '')));
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var totalElement = document.querySelector('.total-population');
var totalValue = statistic.reduce(function(sum, item) {
    return sum + item;
}, 0);
totalElement.textContent = '';
totalElement.insertAdjacentText('afterbegin', totalValue.toLocaleString('en-US'));
var average = document.querySelector('.average-population');
average.textContent = '';
average.insertAdjacentText('afterbegin', Math.ceil(totalValue / statistic.length).toLocaleString('en-US'));

//# sourceMappingURL=js_get_data_DOM.3aa04b6a.js.map
